import cloneDeep from 'lodash-es/cloneDeep';

import { selectDesign } from '@/store/designer/selectors';
import { startEditingAction } from '../designerReducer';

export const startEditingDesign = designID => (dispatch, getState) => {
  const design = cloneDeep(selectDesign(getState(), designID));
  dispatch(startEditingAction(design));
};
